(function (factory) {
  if (typeof define === "function" && define.amd) {
    define(["jquery"], factory);
  } else if (typeof module === "object" && module.exports) {
    module.exports = function (root, jQuery) {
      if (jQuery === undefined) {
        if (typeof window !== "undefined") {
          jQuery = require("jquery");
        } else {
          jQuery = require("jquery")(root);
        }
      }
      factory(jQuery);
      return jQuery;
    };
  } else {
    factory(jQuery);
  }
})(function ($) {
  "use strict";

  var pluginName = "liveSearch",
    defaults = {
      path: null,
      action: null,
      perPage: 10,
      useLive: true,
      useQueryString: true,
      submit: ".live-submit",
      reset: ".live-reset",
      filters: ".live-filter",
      order: ".live-order",
    };

  // The actual plugin constructor
  function LiveSearch(element, options) {
    this.element = element;
    defaults.resultsContainer = element;
    defaults.paginationContainer = element;
    defaults.render = function (item) {
      $(element).fadeIn("<div>" + item + "</div>");
    };

    this.settings = $.extend({}, defaults, options);
    this._defaults = defaults;
    this._name = pluginName;
    this.filters = {};

    var _this = this;

    $(document).ready(function () {
      if (_this.settings.useQueryString) {
        _this.filters = _this.getQueryParams();
        if (!$.isEmptyObject(_this.filters)) {
          $.each(_this.filters, function (key, val) {
            $(_this.settings.filters)
              .filter("[name='" + key + "']")
              .val(val);
            $(_this.settings.order)
              .filter("[name='" + key + "']")
              .val(val);
          });
        }
      }

      $(element).trigger("livesearch.loaded", _this.filters);
      _this.getDatas();
      _this.init();
    });
  }

  // Avoid Plugin.prototype conflicts
  $.extend(LiveSearch.prototype, {
    init: function () {
      var _this = this;

      $(document).on("change", this.settings.filters, function (e) {
        $(_this.element).trigger("livesearch.filterChange");
      });
      $(document).on("change", this.settings.order, function (e) {
        $(_this.element).trigger("livesearch.orderChanged");
      });
      $(document).on("click", this.settings.reset, function (e) {
        $(_this.element).trigger("livesearch.reset");
      });
      $(document).on("click", this.settings.submit, function (e) {
        $(_this.element).trigger("livesearch.submit");
      });
      $(document).on("click", "[data-page]", function (e) {
        $(_this.element).trigger(
          "livesearch.pageChange",
          $(this).attr("data-page")
        );
      });

      $(this.element).bind("livesearch.pageChange", function (event, page) {
        _this.filters["page-nb"] = page;
        _this.addToQuery();
        if (_this.settings.useLive) {
          _this.getDatas();
        }
      });

      $(this.element).bind("livesearch.filterChange", function (event) {
        $(_this.settings.filters).each(function () {
          _this.filters[$(this).attr("name")] = $(this).val();
        });
        _this.filters["page-nb"] = 1;
        _this.addToQuery();
        if (_this.settings.useLive) {
          _this.getDatas();
        }
        $(_this.element).trigger("livesearch.filterChanged", _this.filters);
      });
      $(this.element).bind("livesearch.orderChanged", function (event) {
        $(_this.settings.order).each(function () {
          _this.filters[$(this).attr("name")] = $(this).val();
        });
        _this.addToQuery();
        if (_this.settings.useLive) {
          _this.getDatas();
        }
      });
      $(this.element).bind("livesearch.reset", function (event) {
        _this.filters = {};
        $(_this.settings.filters).val("");
        $(_this.settings.order).val("");
        _this.addToQuery();
        _this.getDatas();
      });
      $(this.element).bind("livesearch.submit", function (event) {
        _this.addToQuery();
        _this.getDatas();
      });
    },
    updateQueryStringParam: function (key, value) {
      var baseUrl = [
          location.protocol,
          "//",
          location.host,
          location.pathname,
        ].join(""),
        urlQueryString = document.location.search,
        newParam =
          typeof value == "undefined" || value == null || value == ""
            ? ""
            : key + "=" + value,
        params = "?" + newParam;

      if (urlQueryString) {
        var updateRegex = new RegExp("([\?&])" + key + "[^&]*");
        var removeRegex = new RegExp("([\?&])" + key + "=[^&;]+[&;]?");

        if (typeof value == "undefined" || value == null || value == "") {
          params = urlQueryString.replace(removeRegex, "$1");
          params = params.replace(/[&;]$/, "");
        } else if (urlQueryString.match(updateRegex) !== null) {
          params = urlQueryString.replace(updateRegex, "$1" + newParam);
        } else {
          params = urlQueryString + "&" + newParam;
        }
      }

      params = params == "?" ? "" : params;
      window.history.replaceState({}, "", baseUrl + params);
    },
    addToQuery: function () {
      var _this = this;
      if (this.settings.useQueryString) {
        if (!$.isEmptyObject(this.filters)) {
          $.each(this.filters, function (key, value) {
            _this.updateQueryStringParam(key, value);
          });
        } else {
          _this.updateQueryStringParam("page-nb");
          $(_this.settings.filters).each(function () {
            _this.updateQueryStringParam($(this).attr("name"));
          });
          $(_this.settings.order).each(function () {
            _this.updateQueryStringParam($(this).attr("name"));
          });
        }
      }
    },
    getQueryParams: function () {
      var queryString = window.location.search.slice(1);
      var obj = {};
      if (queryString) {
        queryString = queryString.split("#")[0];
        var arr = queryString.split("&");

        for (var i = 0; i < arr.length; i++) {
          var a = arr[i].split("=");

          var paramName = a[0];
          var paramValue = typeof a[1] === "undefined" ? true : a[1];

          paramName = paramName.toLowerCase();
          if (typeof paramValue === "string")
            paramValue = paramValue.toLowerCase();

          if (paramName.match(/\[(\d+)?\]$/)) {
            var key = paramName.replace(/\[(\d+)?\]/, "");
            if (!obj[key]) obj[key] = [];
            if (paramName.match(/\[\d+\]$/)) {
              var index = /\[(\d+)\]/.exec(paramName)[1];
              obj[key][index] = paramValue;
            } else {
              obj[key].push(paramValue);
            }
          } else {
            paramValue = decodeURIComponent(paramValue);
            paramValue =
              paramValue.indexOf(",") > 0 ? paramValue.split(",") : paramValue;

            if (!obj[paramName]) {
              obj[paramName] = paramValue;
            } else if (obj[paramName] && typeof obj[paramName] === "string") {
              obj[paramName] = [obj[paramName]];
              obj[paramName].push(paramValue);
            } else {
              obj[paramName].push(paramValue);
            }
          }
        }
      }

      return obj;
    },
    getDatas: function () {
      var _this = this;
      var datas = $.extend({}, this.filters, {
        perPage: this.settings.perPage,
        page: this.filters["page-nb"] || 1,
        action: this.settings.action,
      });
      $(_this.settings.resultsContainer).children().fadeOut();
      $(_this.settings.paginationContainer).children().fadeOut();
      $(".empty-news").hide();
      $(".waiting-results").fadeIn();
      $(_this.element).trigger("livesearch.beforeSearch");
      $.ajax({
        method: "GET",
        url: this.settings.path,
        data: datas,
      })
        .done(function (data) {
          $(_this.settings.resultsContainer).children().remove();
          $(_this.settings.paginationContainer).children().remove();
          $.each(data.items, function () {
            $(_this.settings.resultsContainer)
              .append(_this.settings.render(this))
              .hide()
              .fadeIn();
            $(".waiting-results").fadeOut();
          });
          $(_this.settings.resultsContainer).children().show();
          if (data.items && data.items.length) {
            _this.renderPagination(data);
          } else {
            $(_this.settings.paginationContainer).html("");
          }
          $(_this.element).trigger("livesearch.rendered", data);
        })
        .fail(function () {
          $(_this.settings.resultsContainer).children().show();
          $(_this.settings.paginationContainer).children().show();
          $(_this.element).trigger("livesearch.fail");
        });
    },
    paginate: function (c, m, d) {
      var current = c,
        last = m,
        delta = d,
        left = parseInt(current) - delta,
        right = parseInt(current) + delta + 1,
        range = [],
        rangeWithDots = [],
        l;

      for (var i = 1; i <= last; i++) {
        if (i == 1 || i == last || (i >= left && i < right)) {
          range.push(i);
        } else {
          range.push(null);
        }
      }

      for (var i = 0; i < range.length; i++) {
        if (l) {
          if (range[i] - l === 2) {
            rangeWithDots.push(
              '<li class="page-numbers ' +
                (current == range[i] ? "active " : "") +
                '"><a href="#" class="page-link" data-page="' +
                range[i] +
                '">' +
                range[i] +
                "</a></li>"
            );
          } else if (range[i] - l !== 1) {
            rangeWithDots.push(
              '<li class="page-numbers disabled"><span class="page-link">...</span></li>'
            );
          }
        }
        if (range[i]) {
          rangeWithDots.push(
            '<li class="page-numbers ' +
              (current == range[i] ? "active " : "") +
              '"><a href="#begin-listing" class="page-link " data-page="' +
              range[i] +
              '">' +
              range[i] +
              "</a></li>"
          );
        }

        l = range[i];
      }

      return rangeWithDots;
    },
    renderPagination: function (datas) {
      console.log(datas);
      var pagination =
        '<nav id="livesearch-paginator" role="navigation">\n' +
        '   <ul class="livesearch-pagination pagination">\n' +
        '      <li class="button page-item prev ' +
        (1 == parseInt(datas.page) ? "disabled" : "") +
        '"><a href="#" data-page="' +
        (parseInt(datas.page) - 1) +
        '" class="page-link"><div class="btn-with-arrow page-prev btn btn--primary"><i class="icon icon-arrowback" aria-hidden="true"></i>Précédent</div></a></li>\n';

      this.paginate(datas.page, datas.total_pages, 2).forEach(
        function (element, index) {
          pagination += element;
        }
      );

      pagination +=
        '      <li class="button page-item next ' +
        (datas.total_pages == parseInt(datas.page) ? "disabled" : "") +
        '"><a href="#" data-page="' +
        (parseInt(datas.page) + 1) +
        '" class="page-link"><div class="btn-with-arrow page-next btn btn--primary">Suivant<i class="icon icon-arrowright" aria-hidden="true"></i></div></a></li>\n' +
        "   </ul>\n" +
        "</nav>";

      if (datas.total_pages > 1) {
        $(this.settings.paginationContainer).append(pagination);
      }
    },
  });

  // A really lightweight plugin wrapper around the constructor,
  // preventing against multiple instantiations
  $.fn[pluginName] = function (options) {
    return this.each(function () {
      if (!$.data(this, "plugin_" + pluginName)) {
        $.data(this, "plugin_" + pluginName, new LiveSearch(this, options));
      }
    });
  };
});
